import { Component, OnInit } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { IconComponent } from '../../../ui/icon/icon.component';
import { CellActionType } from 'src/app/features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-error',
  standalone: true,
  imports: [
    IconComponent
  ],
  templateUrl: './grid-cell-error.component.html',
  styleUrl: './grid-cell-error.component.scss'
})
export class GridCellErrorComponent extends GridCellBaseComponent<boolean> implements OnInit {
  public iconName: string = '';

  public ngOnInit(): void {
    this.iconName = this.value ? 'circle-exclamation' : '';
  }

  public onIconClick(event: MouseEvent): void {
    event.stopPropagation();
    this.onCellAction.emit({ action: CellActionType.ON_ERROR_CLICK, data: { data: this.data } });
  }

  protected override onDataChanged(): void {
    this.iconName = this.value ? 'circle-exclamation' : '';
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }
}
